import { PublicSchemaType } from '@inkitt/titan/types/publicTypes';
import { z } from 'zod';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore - because the common contracts are used by Galatea, we unfortunately need to disable TS here because the non-strict Galatea build will fail since Zod requires strict mode
export const SaturnCustomSubscription: z.ZodType<PublicSchemaType['CustomSubscription']> = z.object({
  id: z.number(),
  userId: z.string(),
  appName: z.enum(['galatea', 'candyjar']),
  entitlement: z.string(),
  productId: z.string(),
  source: z.string(),
  cancelAt: z.coerce.date().nullable(),
  cancelledAt: z.coerce.date().nullable(),
  startedAt: z.coerce.date(),
  expiresAt: z.coerce.date(),
});

export type SaturnCustomSubscription = z.infer<typeof SaturnCustomSubscription>;
